import React, { useEffect, useState } from "react";
import DefaultLayout from "../../layouts/defaultLayout";
import "./style.css";
import "../subjects/style.css";
import * as FileSaver from "file-saver";
import PageHeader from "../../components/page-header";
import * as XLSX from "xlsx";
import BurdCrumbs from "../../components/burdCrumbs";
import TableLayout from "../../components/table";
import Modal from "../../components/modal";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

import { Loader, Toggle } from "rsuite";
import { ChevDown } from "../../assets/svgIcons";
import { BASE_URL } from "../../constants";
import { userData } from "../../data/fake_login_data";
import { perms } from "../../data/side_nav_data";
const Students = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const banTypes = [
    { id: "1", title: "Manual" },
    { id: "2", title: "Automatic" },
  ];
  const [searchHeaderKet, setSearchHeaderKey] = useState("");
  const [AssignLoading, setAssignLoading] = useState(false);
  let [choosedDocs, setChoosedDocs] = useState([]);
  const [bannedType, setBannedType] = useState(1);
  let [reason, setReason] = useState(null);
  const [reasons, setReasons] = useState(null);
  const [showExport, setShowExport] = useState(false);
  const [loading, setLoading] = useState(false);
  const [banId, setBanId] = useState(false);
  const [resetId, setResetId] = useState(false);
  const [data, setData] = useState(false);
  const [uData, setUData] = useState(false);
  const [stu_id, set_stu_id] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [opened, setOpened] = useState(null);
  const [expandedChains, setExpandedChains] = useState({});
  useEffect(() => {
    if (stu_id) fetchUData();
  }, [stu_id]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (banId) selectReasons();
  }, [banId]);
  const subscribe = async (course_id, sub_type, type) => {
    await axios
      .post(
        type == "yes"
          ? BASE_URL + "subscriptions/add_subscription.php"
          : type == "no"
            ? BASE_URL + "subscriptions/end_subscription.php"
            : "",
        {
          student_id: stu_id?.student_id,
          course_id: course_id,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
          sub_type: sub_type, // course - chapter
        }
      )
      .then((response) => {
        toast.success(response?.data?.message);
      });
    await fetchUData();
  };

  const toggleChainExpansion = (chainIndex) => {
    setExpandedChains(prev => ({
      ...prev,
      [chainIndex]: !prev[chainIndex]
    }));
  };

  const fetchUData = async () => {
    try {
      setAssignLoading(true);
      const response = await axios.post(
        BASE_URL + "students/select_student_material.php",
        {
          student_id: stu_id?.student_id,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
        }
      );

      setAssignLoading(false);
      setUData(response?.data?.message);
    } catch (err) {
      toast.error(err?.message);
      setAssignLoading(false);
    }
  };
  const selectReasons = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "ban/select_ban_reason.php",
        {
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
        }
      );
      setReasons(response?.data?.message);
    } catch (err) {
      setData([]);
      toast.error(err?.message);
    }
  };
  const headers = [
    {
      label: "ID",
      dataIndex: "student_id",
      sort: true,
      search: true,
      equal: true,
    },

    perms?.includes("*7_3") ||
      perms?.startsWith("7_3") ||
      perms?.includes("*7_2") ||
      perms?.startsWith("7_2")
      ? {
        label: "Actions",
        type: "children",
        children: ({ headers, row, index, lastIndex }) => {
          return (
            <div className="modern-action-menu">
              <button
                className="action-toggle-btn"
                onClick={() => {
                  const currentId = row?.course_subscription_id || row?.chapter_subscription_id || row?.student_id;
                  setOpened(
                    opened == currentId ? null : currentId
                  );
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                </svg>
              </button>
              {(row?.course_subscription_id || row?.chapter_subscription_id || row?.student_id) == opened && (
                <div className="modern-actions-dropdown">
                  {perms?.includes("*7_2") || perms?.startsWith("7_2") ? (
                    <button
                      className="action-btn action-btn-danger"
                      onClick={() => {
                        setResetId(false);
                        setBanId(row);
                        setOpened(null);
                      }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                      </svg>
                      Ban Student
                    </button>
                  ) : null}
                  {perms?.includes("*7_3") || perms?.startsWith("7_3") ? (
                    <button
                      className="action-btn action-btn-warning"
                      onClick={() => {
                        setResetId(row);
                        setBanId(false);
                        setOpened(null);
                      }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                      </svg>
                      Reset Student
                    </button>
                  ) : null}
                </div>
              )}
            </div>
          );
        },
      }
      : {},

    perms?.includes("*7_6") || perms?.startsWith("7_6")
      ? {
        label: "Profile",
        type: "children",
        children: ({ headers, row }) => {
          return (
            <div className="profile-action">
              {AssignLoading ? (
                <div className="loading-container">
                  <Loader />
                </div>
              ) : (
                <a
                  className="modern-btn modern-btn-primary"
                  href={"/profile?stu_id=" + row?.student_id}
                  target="_blank"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                  View Profile
                </a>
              )}
            </div>
          );
        },
      }
      : {},

    perms?.includes("*7_4") || perms?.startsWith("7_4")
      ? {
        label: "Assign Subjects",
        type: "children",
        children: ({ headers, row }) => {
          return (
            <div className="assign-action">
              {AssignLoading ? (
                <div className="loading-container">
                  <Loader />
                </div>
              ) : (
                <button
                  className="modern-btn modern-btn-success"
                  onClick={() => set_stu_id(row)}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                  </svg>
                  Assign Subjects
                </button>
              )}
            </div>
          );
        },
      }
      : {},
    perms?.includes("*7_5") || perms?.startsWith("7_5")
      ? {
        label: "SIM Card",
        type: "children",
        children: ({ headers, row }) => {
          return (
            <div className="sim-card-toggle">
              <div className="toggle-container">
                <Toggle
                  checked={row?.sim_card != 0}
                  onChange={async () => {
                    try {
                      const response = await axios.post(
                        BASE_URL + "students/update_sim_card.php",
                        {
                          student_id: row?.student_id,
                          admin_id: userData?.user_id,
                          access_token: userData?.access_token,
                          sim_card: row?.sim_card == 0 ? 1 : 0,
                        }
                      );
                      if (response.data?.status == "success") {
                        toast.success(response.data?.message);
                        fetchData();
                        setResetId(false);
                        setLoading(false);
                      } else {
                        setLoading(false);
                        toast.error(response.data?.message);
                      }
                    } catch (err) {
                      toast.error(err?.message);
                      setLoading(false);
                    }
                  }}
                  className="modern-toggle"
                />
                <span className={`toggle-label ${row?.sim_card != 0 ? 'active' : ''}`}>
                  {row?.sim_card != 0 ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
          );
        },
      }
      : {},
    {
      label: "Reset Count",
      type: "children",
      children: ({ headers, row }) => {
        return <div>{row?.reset_count}</div>;
      },
    },
    {
      label: "Student Name",
      dataIndex: "student_name",
      search: location?.state?.course_id ? false : true,
      sort: location?.state?.course_id ? false : true,
      type: "children",
      children: ({ headers, row }) => {
        return location?.state?.course_id || location?.state?.chapter_id ? row?.student_data?.student_name : row?.student_name
      }

      // sort: true,
    },
    {
      label: "Student Phone",
      dataIndex: "student_phone",
      search: location?.state?.course_id ? false : true,
      sort: location?.state?.course_id ? false : true,
      type: "children",
      children: ({ headers, row }) => {
        return location?.state?.course_id || location?.state?.chapter_id ? row?.student_data?.student_phone : row?.student_phone
      }
    },
    // {
    //   label: "Student Serial",
    //   dataIndex: "student_serial",
    //   search: true,
    //   sort: true,
    // },
  ];
  window.addEventListener("click", (e) => {
    if (
      opened &&
      !e.target?.classList?.contains("modern-actions-dropdown") &&
      !e.target?.classList?.contains("action-btn") &&
      !e.target?.classList?.contains("action-toggle-btn") &&
      !e.target?.closest(".modern-action-menu")
    ) {
      setOpened(null);
    }
  });
  const exportToCSV = (apiData, fileName) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  // const fetchData = async () => {
  //   try {
  //     const response = await axios.post(
  //       BASE_URL + "students/select_student_sub_course.php",
  //       {
  //         course_id: location?.state?.course_id,
  //         admin_id: userData?.user_id,
  //         access_token: userData?.access_token,
  //       }
  //     );

  //     setData(response?.data?.massage);
  //   } catch (err) {
  //     setData([]);
  //     toast.error(err?.massage);
  //   }
  // };
  const fetchData = async () => {
    try {
      const response = await axios.post(

        BASE_URL + (!location?.state?.course_id ? "students/select_all_students.php" : location?.state?.chapter_id ? "students/select_student_sub_chapter.php" : "students/select_student_sub_course.php"),
        {
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
          course_id: location?.state?.course_id,
          chapter_id: location?.state?.chapter_id,

        }
      );

      setData(response?.data?.message || response?.data?.massage);
    } catch (err) {
      setData([]);
      toast.error(err?.message);
    }
  };
  const handleDeletePhone = () => {
    const data_send = {
      student_id: deleteId?.student_id,
      admin_id: userData?.user_id,
      access_token: userData?.access_token,
    };
    axios
      .post(
        BASE_URL + "students/delete_student_new.php",
        JSON.stringify(data_send)
      )
      .then((res) => {
        if (res.data.status == 'success') {
          toast.success(res.data.message);
          setDeleteId(false);
          fetchData();
        } else if (res.data.status == 'error') {
          toast.error(res.data.message);
        } else {
          toast.error("Something Went Error");
        }
      });
  };
  const resetUser = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        BASE_URL + "students/update_serial.php",
        {
          student_id: resetId?.student_id,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
        }
      );
      if (response.data?.status == "success") {
        toast.success(response.data?.message);
        fetchData();
        setResetId(false);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.data?.message);
      }

      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };

  const addBanStudent = async () => {
    setLoading(true);

    try {
      const response = await axios.post(BASE_URL + "ban/insert_ban_user.php", {
        Ban_reason: reason,
        admin_id: userData?.user_id,
        student_id: banId?.student_id,
        Banned_type: "Manual",
        Banned_by: userData?.user_id,
        access_token: userData?.access_token,
      });

      if (response.data?.status == "success") {
        if (response.data?.message) {
          toast.success(response.data?.message);
          fetchData();
          setBanId(null);
          setLoading(false);
        } else {
          toast.error("This Student has already banned");
          setBanId(null);
          setLoading(false);
        }
      } else {
        setLoading(false);
        toast.error(response.data?.message);
      }

      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      document.querySelectorAll(".chain") &&
      document.querySelectorAll(".chain")?.length
    ) {
      document.querySelectorAll(".chain").forEach((value, index, array) => {
        if (value[index] && value[index].querySelector("li")) {
          value[index].querySelector("li").style.height = 0;
          value[index].style.overflow = "hidden";
        }
        value.querySelector("span").addEventListener("click", (e) => {
          const valueLength = value.querySelector("li");
          if (parseInt(valueLength.style.height.split("px")[0])) {
            valueLength.style.height = 0;
            valueLength.style.overflow = "hidden";
            if (value.querySelector("span svg"))
              value.querySelector("svg").classList.remove("active");
          } else {
            valueLength.style.height = valueLength?.scrollHeight + "px";
            valueLength.style.overflow = "auto";
            if (value.querySelector("span svg"))
              value.querySelector("svg").classList.add("active");
          }
        });
      });

      // ==============================================
      document
        .querySelectorAll("ul.chain > li > ul > li ")
        .forEach((value, index, array) => {
          value.querySelector("span").addEventListener("click", (e) => {
            const valueLength = value.querySelector("ul");
            if (parseInt(valueLength.style.height.split("px")[0])) {
              valueLength.style.height = 0;
              valueLength.style.overflow = "hidden";
              if (value.querySelector("span svg"))
                value.querySelector("span svg").classList.remove("active");
            } else {
              valueLength.style.height = valueLength?.scrollHeight + "px";
              valueLength.style.overflow = "auto";
              if (value.querySelector("span svg"))
                value.querySelector("span svg").classList.add("active");
            }
          });
        });
    }
  }, [uData, stu_id, document, fetchData, fetchUData, data]);

  return (
    <div id="home">
      <DefaultLayout
        setSearchHeaderKey={setSearchHeaderKey}
        children={
          <div className="childs">
            <PageHeader
              title={"Students Management"}
              description="Manage students, subscriptions, and academic progress"
              exportButton={perms?.includes("*17_3") || perms?.startsWith("17_3")}
              data={data}
            />
            {/* <BurdCrumbs title={"Students"} /> */}
            {/* {perms?.includes("*17_3") || perms?.startsWith("17_3") ? (
              <button
                className="btn btn-primary"
                onClick={() => {
                  exportToCSV(data, "Student Data");
                }}
              >
                Export
              </button>
            ) : null} */}
            <TableLayout
              searchHeaderKet={searchHeaderKet}
              headers={headers}
              data={data}
            />

            <Modal
              open={showExport}
              toggle={setShowExport}
              headerTitle={"Export Data As Excel File"}
              children={
                <div className="flex-box">
                  {choosedDocs && choosedDocs?.length ? (
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        exportToCSV(choosedDocs, "cients Data");
                      }}
                    >
                      Export Only Selected
                    </button>
                  ) : null}

                  <button
                    className="btn btn-primary"
                    width={"fit-content"}
                    onClick={() => {
                      exportToCSV(data, "Student Data");
                    }}
                  >
                    Export all Data
                  </button>
                </div>
              }
            />

            <Modal
              open={banId}
              toggle={setBanId}
              headerTitle={"Ban Student"}
              children={
                <div className="modern-modal-content">
                  <div className="modal-warning">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                    </svg>
                    <h3>Confirm Student Ban</h3>
                    <p>Are you sure you want to ban <strong>{banId?.student_name}</strong>?</p>
                  </div>

                  <div className="form-group">
                    <label htmlFor="ban-reason">Select Ban Reason</label>
                    <select
                      id="ban-reason"
                      className="modern-select"
                      onChange={(e) => {
                        setReason(
                          reasons?.filter(
                            (item) => item.ban_reason_id == e.target.value
                          )[0]?.ban_reason
                        );
                      }}
                    >
                      <option value="">Choose a reason...</option>
                      {!reasons ? (
                        <option disabled>Loading reasons...</option>
                      ) : reasons && reasons?.length && Array.isArray(reasons) ? (
                        reasons.map((item, index) => {
                          return (
                            <option key={item?.ban_reason_id} value={item?.ban_reason_id}>
                              {item?.ban_reason}
                            </option>
                          );
                        })
                      ) : null}
                    </select>
                  </div>

                  <div className="modal-button-container">
                    <button
                      className="modal-btn modal-btn-danger"
                      onClick={() => {
                        return !loading ? addBanStudent() : null;
                      }}
                      disabled={loading}
                    >
                      {loading ? (
                        <div className="button-loading">
                          <div className="spinner"></div>
                          <span>Banning...</span>
                        </div>
                      ) : (
                        <div className="button-content">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                          </svg>
                          <span>Confirm Ban</span>
                        </div>
                      )}
                    </button>

                    <button
                      className="modal-btn modal-btn-secondary"
                      onClick={() => {
                        setBanId(false);
                      }}
                    >
                      <div className="button-content">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </svg>
                        <span>Cancel</span>
                      </div>
                    </button>
                  </div>
                </div>
              }
            />

            <Modal
              open={resetId}
              toggle={setResetId}
              headerTitle={"Reset Student"}
              children={
                <div className="modern-modal-content">
                  <div className="modal-warning">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                    </svg>
                    <h3>Confirm Student Reset</h3>
                    <p>Are you sure you want to reset <strong>{resetId?.student_name}</strong>?</p>
                    <div className="reset-info">
                      <p>This action will reset the student's progress and data.</p>
                    </div>
                  </div>

                  <div className="modal-button-container">
                    <button
                      className="modal-btn modal-btn-warning"
                      onClick={() => {
                        return !loading ? resetUser() : null;
                      }}
                      disabled={loading}
                    >
                      {loading ? (
                        <div className="button-loading">
                          <div className="spinner"></div>
                          <span>Resetting...</span>
                        </div>
                      ) : (
                        <div className="button-content">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
                          </svg>
                          <span>Confirm Reset</span>
                        </div>
                      )}
                    </button>

                    <button
                      className="modal-btn modal-btn-secondary"
                      onClick={() => {
                        setResetId(false);
                      }}
                    >
                      <div className="button-content">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </svg>
                        <span>Cancel</span>
                      </div>
                    </button>
                  </div>
                </div>
              }
            />

            <Modal
              open={deleteId}
              toggle={setDeleteId}
              headerTitle={"Delete Student"}
              children={
                <div className="modern-modal-content">
                  <div className="modal-warning delete-warning">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" />
                    </svg>
                    <h3>Confirm Student Deletion</h3>
                    <p>Are you sure you want to delete <strong>{deleteId?.student_name}</strong>?</p>
                    <div className="delete-info">
                      <p>This action cannot be undone. All student data will be permanently removed.</p>
                    </div>
                  </div>

                  <div className="modal-button-container">
                    <button
                      className="modal-btn modal-btn-danger"
                      onClick={() => {
                        handleDeletePhone();
                      }}
                    >
                      <div className="button-content">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
                        </svg>
                        <span>Delete Student</span>
                      </div>
                    </button>

                    <button
                      className="modal-btn modal-btn-secondary"
                      onClick={() => {
                        setDeleteId(false);
                      }}
                    >
                      <div className="button-content">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </svg>
                        <span>Cancel</span>
                      </div>
                    </button>
                  </div>
                </div>
              }
            />

            <Modal
              open={uData}
              toggle={() => {
                setUData(false);
                set_stu_id(false);
              }}
              headerTitle={
                "Assign Subjects to " + stu_id?.student_name
              }
              children={
                <div className="modern-subscription-modal">
                  <div className="student-info">
                    <div className="student-avatar">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                      </svg>
                    </div>
                    <div className="student-details">
                      <h3>{stu_id?.student_name}</h3>
                      <p>Student ID: {stu_id?.student_id}</p>
                    </div>
                  </div>

                  <div className="subscription-container p-3">
                    <h4>Available Subjects & Courses</h4>
                    <div className="chains-container">
                      {uData && uData?.length ? (
                        uData?.map((item, index) => {
                          return (
                            <div key={index} className="chain-card">
                              <div
                                className="chain-header"
                                onClick={() => toggleChainExpansion(index)}
                              >
                                <div className="chain-info">
                                  <h5>{item?.chain_name}</h5>
                                  <span className="chain-count">
                                    {item?.courses?.length || 0} courses
                                  </span>
                                </div>
                                <button
                                  className={`expand-btn ${expandedChains[index] ? 'expanded' : ''}`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleChainExpansion(index);
                                  }}
                                >
                                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                                  </svg>
                                </button>
                              </div>

                              <div className={`courses-container ${expandedChains[index] ? 'expanded' : 'collapsed'}`}>
                                {!item?.courses ? (
                                  <div className="loading-state">
                                    <Loader />
                                    <span>Loading courses...</span>
                                  </div>
                                ) : item?.courses?.length ? (
                                  item?.courses?.map((c_item, cIndex) => {
                                    return (
                                      <div key={cIndex} className="course-card">
                                        <div className="course-header">
                                          <div className="course-info">
                                            <h6>{c_item?.course_name}</h6>
                                            <span className="course-status">
                                              {c_item?.subscribed === "yes" ? "Subscribed" : "Not Subscribed"}
                                            </span>
                                          </div>
                                          <button
                                            onClick={(e) => {
                                              return c_item?.subscribed === "no"
                                                ? subscribe(c_item?.course_id, "course", "yes")
                                                : subscribe(c_item?.course_id, "course", "no");
                                            }}
                                            className={`subscription-btn ${c_item?.subscribed === "no" ? "subscribe" : "unsubscribe"
                                              }`}
                                          >
                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                              {c_item?.subscribed === "no" ? (
                                                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                                              ) : (
                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                              )}
                                            </svg>
                                            {c_item?.subscribed === "no" ? "Subscribe" : "Unsubscribe"}
                                          </button>
                                        </div>

                                        {c_item?.chapters && c_item?.chapters?.length > 0 && (
                                          <div className="chapters-container">
                                            <h6>Chapters:</h6>
                                            <div className="chapters-list">
                                              {c_item?.chapters?.map((s_item, sIndex) => {
                                                return (
                                                  <div key={sIndex} className="chapter-item">
                                                    <span className="chapter-name">{s_item?.chapter_title}</span>
                                                    <button
                                                      onClick={() => {
                                                        return s_item?.subscribed === "no"
                                                          ? subscribe(s_item?.chapter_id, "chapter", "yes")
                                                          : subscribe(s_item?.chapter_id, "chapter", "no");
                                                      }}
                                                      className={`chapter-btn ${s_item?.subscribed === "no" ? "subscribe" : "unsubscribe"
                                                        }`}
                                                    >
                                                      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                                        {s_item?.subscribed === "no" ? (
                                                          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                                                        ) : (
                                                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                        )}
                                                      </svg>
                                                      {s_item?.subscribed === "no" ? "Subscribe" : "Unsubscribe"}
                                                    </button>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="no-courses">
                                    <p>No courses available in this chain</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="no-data">
                          <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                          </svg>
                          <p>No subjects available for this student</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              }
            />
          </div>
        }
      />
    </div>
  );
};

export default Students;
